import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingConfirmationPage } from '../../../../../features/parking/ui/booking-pages/new-booking/NewBookingConfirmationPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingConfirmationPage;
